import { render, staticRenderFns } from "./PatientProfileDashboardPage.vue?vue&type=template&id=3f655f5b&scoped=true"
import script from "./PatientProfileDashboardPage.vue?vue&type=script&lang=js"
export * from "./PatientProfileDashboardPage.vue?vue&type=script&lang=js"
import style0 from "./PatientProfileDashboardPage.vue?vue&type=style&index=0&id=3f655f5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f655f5b",
  null
  
)

export default component.exports